// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\niframe[data-v-8a4a276e] {\r\n  display: block;       /* iframes are inline by default */\r\n  background: #000;\r\n  border: none;         /* Reset default border */\r\n  height: 100vh;        /* Viewport-relative units */\r\n  width: 100vw;\r\n  margin: 50px;\n}\r\n", ""]);
// Exports
module.exports = exports;
